import { createFileRoute } from "@tanstack/react-router";

import { AiOpsCenter } from "@/pages/admin/AiOpsCenter";

export const Route = createFileRoute("/admin/aiops")({
  component: AiOpsCenter,
});
